import { FC, useState } from 'react';

import { useCompanyHolders } from 'hooks';

import { OfficeholdersTable } from '../../../shared';
import { TabProps } from '../../types';
import { OfficeholderAddress } from './components';

interface OfficeholdersProps extends TabProps {
  cognitoID: string;
}

const Officeholders: FC<OfficeholdersProps> = ({ company, cognitoID }) => {
  const [expandedRowID, setExpandedRowID] = useState<number>();
  const { data, isLoading } = useCompanyHolders({
    companyID: company.id,
    cognitoID,
    subRoute: 'officeholders',
  });

  return (
    <OfficeholdersTable
      isLoading={isLoading}
      data={data}
      expandable={{
        expandedRowKeys: expandedRowID ? [expandedRowID] : [],
        onExpand: (expanded, { id }) => {
          setExpandedRowID(expanded ? id : undefined);
        },
        expandedRowRender: () => (
          <OfficeholderAddress
            residentAddressID={
              data.find((item) => item.id === expandedRowID)?.residentAddressID
            }
          />
        ),
      }}
    />
  );
};

export default Officeholders;
